import React, { useEffect, useState } from 'react'

// Libs
import { Col, Form } from 'react-bootstrap';

// Styles m' Resources
import ImgDefault from "../../../../Resources/Images/Networking/photo.png"
import Imgbackground from "../../../../Resources/Images/Networking/red-contacto.png"
import "./PageCommunityNetworking.css";

// Features
import FeatureListSectores from '../../../../Core/Features/FeaturesITT/FeatureListSectores';
import FeatureRegisterBranding from '../../../../Core/Features/FeaturesITT/FeatureRegistrarBranding';

// Hooks
import useModal from '../../../../Hooks/useModal';
import { useNavigate } from 'react-router-dom';

const PageComunityRegister = () => {
    const { 
        loading, 
        respondeDtoRetrieveBrandig, 
        requestDtoRegistrarBranding, 
        responseDtoRegistrarBranding,
        uploadingImage,
        UpdateBranding, 
        RetrieveBranding, 
        handleInputChange, 
        handlePhotoCurriculum, 
        handleInputChangeIdentidad, 
    } = FeatureRegisterBranding();
    const { sectors, getSectors } = FeatureListSectores();

    const [DataSector, setDataSector] = useState(sectors);
    const [PhotoCommunity, setPhotoCommunity] = useState(ImgDefault);
    const [DataComunity, setDataComunity] = useState(requestDtoRegistrarBranding);
    const [formatImageUploading, setFormatImageUploading] = useState("");

    const navigate = useNavigate();
    const [ModalComponent, setShow] = useModal();
       
    const validaTelefono = (tel) => {
        return (Number(tel) <= 9999999999 && tel.length<=10) 
    } 

    const validarForm = () => {
        return requestDtoRegistrarBranding.idSector && requestDtoRegistrarBranding.nombreEmpresa && requestDtoRegistrarBranding.mailEmpresarial && requestDtoRegistrarBranding.telefonoEmpresarial;
    }
    
    const handleSubmit =(e)=> {
        e.preventDefault();
        validarForm() && UpdateBranding(requestDtoRegistrarBranding.idEmpresa);
    }

    //Subir y reemplazar imagen de emprendimiento
    const OnloadPhoto = async (e)=>{
        await handlePhotoCurriculum(e);
        let formatoImagen = e.target.value.split('.');
        setFormatImageUploading(formatoImagen[1]);
    }
    
    useEffect(() => {
        RetrieveBranding();
        getSectors();
    }, []);

    useEffect(() => {
        setShow(loading);
    }, [loading]);
    
    useEffect(() => {
        setDataComunity(requestDtoRegistrarBranding);
        setDataSector(sectors);
        if(!uploadingImage){
            setPhotoCommunity(requestDtoRegistrarBranding.rutaImagen);
        } else {
            setPhotoCommunity(`data:image/${formatImageUploading};base64,${requestDtoRegistrarBranding.rutaImagen}`);
        }
    }, [requestDtoRegistrarBranding])

    useEffect(() => {
        respondeDtoRetrieveBrandig.hasOwnProperty('codigo') && respondeDtoRetrieveBrandig.codigo == -1 && navigate('/comunidad-emprendedores-agregar')
    }, [respondeDtoRetrieveBrandig])
    
    

    useEffect(() => {
        responseDtoRegistrarBranding.mensaje == "Branding actualizado" && navigate('/networking')
    }, [responseDtoRegistrarBranding])
    
    useEffect(() => {
      setDataSector(sectors);
    }, [sectors])
    

  return (
      <div className="Container__ContactCommunity">
        <ModalComponent
        title="My Modal"
        body="This is the body of my modal."
        loader={true}
      />
        <div className="SubContainer__ContactCommunity">
            <img src={Imgbackground} className="Img__background"/>
        </div>
        <div className="SubContainer__ContactCommunity Form__RegisterComunity">
            <h1 className="Title__RegisterComunity">Red de contactos</h1>
            <h4 className="fontCIBBook fw-400 font16px">Estos son los datos de tu empresa</h4>
            <div className="Big__Container">
                <form onSubmit={(e)=>handleSubmit(e)}>
                    <div className="Container__FormRegisterComunityFhater">
                        <div className="Container__FormRegisterComunitiOne pe-4">
                            <div>
                                <label for="GET-name" className='fontCIBBook fw-400 font16px'>*Nombre de la empresa</label>
                                <input 
                                    id="GET-name"
                                    type="text" 
                                    name="name" 
                                    placeholder="Nombre empresarial" 
                                    value={DataComunity.nombreEmpresa}
                                    onChange={({target})=>{handleInputChange(target.value, 'nombreEmpresa')}}
                                    />
                            </div>
                            <div>
                                <label for="GET-sector" className='fontCIBBook fw-400 font16px'>Sector de la empresa</label>
                                <select 
                                    id="GET-sector" 
                                    type="text" 
                                    name="sector" 
                                    placeholder="Selecciona un sector"
                                    onChange={({target})=>{
                                        DataComunity.idSector = target.value
                                        handleInputChange(sectors.find((sector) => sector.id == target.value).text, 'nombreSector')
                                    }}
                                    value={DataComunity.idSector}
                                    >
                                    <option value="0">Selecciona un sector</option>
                                    {DataSector.length > 0&&
                                        DataSector.map((x)=>{
                                            return( <option value={x.id}>{x.text.length > 50 ? x.text.split(",")[0] : x.text}</option>) 
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="Container__FormRegisterComunitiOne Input__FileImg">
                            <h4>Logo</h4>
                            <img src={PhotoCommunity} onClick={()=>{document.getElementById("PhotoFile").click()}}/>
                            <div className='position__imagen__hv'>
                            <input 
                                type="file" 
                                id="PhotoFile" 
                                accept="image/*" 
                                className='input__photo__hv'
                                onChange={(e)=>{OnloadPhoto(e)}}/>
                                {
                                    PhotoCommunity !== ImgDefault && (
                                        <p className='label__photo__hv'>
                                            +
                                        </p>
                                    )
                                }
                            </div>                            
                        </div>
                    </div>
                    <div className="Container__FormRegisterComunitiTwo pe-4">
                        <div>
                            <label for="GET-mail" className='ms-1 me-3 fontCIBBook'>*Correo electrónico de tu empresa</label>
                            <input 
                                id="GET-mail" 
                                type="email" 
                                name="mail" 
                                placeholder="Correo empresarial" 
                                value={DataComunity.mailEmpresarial}
                                onChange={({target})=>{handleInputChange(target.value, 'mailEmpresarial')}}
                                />
                        </div>
                        <div className='ps-4'>
                            <label for="GET-number" className='ms-1 me-3 fontCIBBook'>*Número telefónico de tu empresa</label>
                            <input 
                                id="GET-number" 
                                type="number" 
                                name="number" 
                                placeholder="Ingresa el número" 
                                value={DataComunity.telefonoEmpresarial}
                                onChange={({target})=>{
                                    const isValid = validaTelefono(target.value)
                                    if (isValid) handleInputChange((target.value).replaceAll(' ', ''), 'telefonoEmpresarial')
                                }}
                                />
                        </div>
                    </div>
                    <Col className='col-12'>
                        <div key={`inline-checkbox`} className="d-flex justify-content-between ps-3 py-5">
                            <Form.Check
                                inline
                                label={<span className='ms-1 me-3 fontCIBBook'>Logo</span>}
                                name="group1"
                                type='checkbox'
                                id={`inline-checkbox-2`}
                                className="class__form__checkbox checkboxes px-3"
                                value={JSON.parse(requestDtoRegistrarBranding.identidadDigital)?.logoCheck}
                                checked={JSON.parse(requestDtoRegistrarBranding.identidadDigital).logoCheck}
                                onChange={(e) => handleInputChangeIdentidad(e.target.checked, 'logoCheck')}
                            />
                            <Form.Check
                                inline
                                label={<span className='ms-1 me-3 fontCIBBook'>Redes sociales</span>}
                                name="group1"
                                type='checkbox'
                                id={`inline-checkbox-3`}
                                className="class__form__checkbox checkboxes px-3"
                                value={requestDtoRegistrarBranding.identidadDigital.paginaWebCheck}
                                checked={JSON.parse(requestDtoRegistrarBranding.identidadDigital).paginaWebCheck}
                                onChange={(e) => handleInputChangeIdentidad(e.target.checked, 'paginaWebCheck')}
                            />
                            <Form.Check
                                inline
                                label={<span className='ms-1 me-3 fontCIBBook'>Página web</span>}
                                name="group1"
                                type='checkbox'
                                id={`inline-checkbox-4`}
                                className="class__form__checkbox checkboxes px-3"
                                value={requestDtoRegistrarBranding.identidadDigital.portafolioCheck}
                                checked={JSON.parse(requestDtoRegistrarBranding.identidadDigital).portafolioCheck}
                                onChange={(e) => handleInputChangeIdentidad(e.target.checked, 'portafolioCheck')}
                            />
                            <Form.Check
                                inline
                                label={<span className='ms-1'>Portafolio</span>}
                                name="group1"
                                type='checkbox'
                                id={`inline-checkbox-5`}
                                className="class__form__checkbox checkboxes px-3"
                                value={requestDtoRegistrarBranding.identidadDigital.redesSocialesCheck}
                                checked={JSON.parse(requestDtoRegistrarBranding.identidadDigital).redesSocialesCheck}
                                onChange={(e) => handleInputChangeIdentidad(e.target.checked, 'redesSocialesCheck')}
                            />
                        </div>
                    </Col>
                    <div className="w-100 pt-2 text-center mt-2">
                        <button onClick={(e)=>handleSubmit(e)} className="Btn__Update fontCIBFont"> Guardar cambios</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}

export default PageComunityRegister